import ReactDOM from "react-dom/client";
import App from "./components/app/App";
import { Provider } from "react-redux";
import "./i18n/i18n";
import store from "./store";
import "./styles.css";
import { BrowserRouter as Router } from "react-router-dom";
import {Consts} from "./components/pages/consts";

const root = ReactDOM.createRoot(document.getElementById(Consts.ROOT));

root.render(
  <Provider store={store}>
    <Router>
      <App />
    </Router>
  </Provider>,
);
